import React from "react"
import { Navigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { ROUTES } from "constants/routes"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import LoginOtp from "../pages/Authentication/LoginOtp"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Locations from "../pages/Locations/index"
import AddLocation from "../pages/Locations/AddLocation"
import Roles from "pages/Roles/Roles"
import AddRoles from "pages/Roles/AddRoles"
import Users from "pages/UserManagement/Users"
import AddUser from "pages/UserManagement/AddUser"
import ViewUser from "pages/UserManagement/ViewUser"
import Customers from "pages/CustomerManagement/Customers"
import CustomersView from "pages/CustomerManagement/CustomersView"
import CustomerLoyalty from "pages/CustomerManagement/CustomerLoyalty"
import Categories from "pages/Menus/Categories/Categories"
import CategoryDetails from "pages/Menus/Categories/CategoryDetails"
import AddCategory from "pages/Menus/Categories/AddCategory"
import Items from "pages/Menus/Items/Items"
import AddItem from "pages/Menus/Items/AddItem"
import EditItem from "pages/Menus/Items/EditItem"
import ModifierGroups from "pages/Menus/Modifiers/ModifierGroups"
import AddModifierGroup from "pages/Menus/Modifiers/AddModifierGroup"
import ModifiersItems from "pages/Menus/Modifiers/ModifiersOptions/ModifiersOptions"
import AddModifierOption from "pages/Menus/Modifiers/ModifiersOptions/AddModifierOption"

import VerifyPassword from "pages/Authentication/VerifyPassword"
import Banners from "pages/Banners/Banners"
import AddSlide from "pages/Banners/AddSlide"
import OfferBanners from "pages/Banners/OfferBanners"
import OfferAddSlide from "pages/Banners/OfferAddSlide"
import ResetPassword from "pages/Authentication/ResetPassword"
import ForbiddenAccess from "pages/Authentication/ForbiddenAccess"
import ViewLocation from "pages/Locations/ViewLocation"
import Orders from "pages/Orders/Orders"
import B2cOrders from "pages/Orders/B2cOrders"
import OrdersHub from "pages/Orders/OrdersHub"
import BrandOrdersPage from "pages/Orders/BrandOrdersPage"
import ViewOrder from "pages/Orders/ViewOrder"
import Countries from "pages/Countries/Countries"
import Brands from "pages/Brands/Brands"
import AddBrand from "pages/Brands/AddBrand"
import BrandDetails from "pages/Brands/BrandDetails"
import ChangePassword from "pages/Authentication/ChangePassword"
import MyPreference from "pages/Authentication/MyPreference"
import Tax from "pages/Settings/Tax"
import UserActivity from "pages/UserManagement/UserActivity"
import UserActivityDetails from "pages/UserManagement/UserActivityDetails"
import ItemDetails from "pages/Menus/Items/ItemDetails"
import ModifierGroupDetails from "pages/Menus/Modifiers/ModifierGroupDetails"
import ModifierOptionDetails from "pages/Menus/Modifiers/ModifiersOptions/ModifierOptionDetails"
import EditCustomer from "pages/CustomerManagement/EditCustomer"
import RolesDetails from "pages/Roles/RolesDetails"
import ApiLogs from "pages/ApiLogs/ApiLogs"
import ApiLogsDetails from "pages/ApiLogs/ApiLogsDetails"
// import Ratings from "pages/Ratings/Ratings"
// import RatingDetails from "pages/Ratings/RatingDetails"
import Promotions from "pages/Promotions/Promotions"
import AddPromotion from "pages/Promotions/AddPromotion"
import CouponsGroups from "pages/CouponsGroups/CouponsGroups"
import PromotionDetails from "pages/Promotions/PromotionDetails"
import Coupons from "pages/CouponsGroups/Coupons"
import AddCoupon from "pages/CouponsGroups/AddCoupon"
import AddBulkCoupon from "pages/CouponsGroups/AddBulkCoupon"
import CouponUsage from "pages/CouponsGroups/CouponUsage"
import CouponUsageDetails from "pages/CouponsGroups/CouponUsageDetails"
import ReferralInfo from "pages/Settings/ReferralInfo"
import LoyaltyPointInfo from "pages/Settings/LoyaltyPointInfo"
import AppNotifications from "pages/Notifications/AppNotifications"
import EditAppNotification from "pages/Notifications/EditAppNotification"
import PushNotification from "pages/Notifications/PushNotifications"
import AppNotificationDetails from "pages/Notifications/AppNotificationDetails"
import CouponDetails from "pages/CouponsGroups/CouponDetails"
import CouponRedeem from "pages/CouponRedeem/CouponRedeem"
import AddCouponRedeem from "pages/CouponRedeem/AddCouponRedeem"
import CouponRedeemDetails from "pages/CouponRedeem/CouponRedeemDetails"
import AddCountry from "pages/Countries/AddCountry"
import CountryDetails from "pages/Countries/CountryDetails"
import IssueLists from "pages/CustomerSupport/IssueLists"
import AddIssue from "pages/CustomerSupport/AddIssue"
import IssueDetails from "pages/CustomerSupport/IssueDetails"
import TicketLists from "pages/CustomerSupport/TicketLists"
import TicketDetails from "pages/CustomerSupport/TicketDetails"
import Ingredients from "pages/Settings/Ingredients/Ingredients"
import AddIngredient from "pages/Settings/Ingredients/AddIngredient"
import IngredientDetails from "pages/Settings/Ingredients/IngredientDetails"
import ItemTags from "pages/Settings/ItemTags/ItemTags"
import AddItemTag from "pages/Settings/ItemTags/AddItemTag"
import Allergens from "pages/Settings/Allergens/Allergens"
import AddAllergen from "pages/Settings/Allergens/AddAllergen"
import AllergenDetails from "pages/Settings/Allergens/AllergenDetails"
import AddLoyaltyPoints from "pages/CustomerManagement/AddLoyaltyPoints"
import SalesReports from "pages/Reports/SalesReports"
import PaymentsReports from "pages/Reports/PaymentsReports"
import BusinessTaxReports from "pages/Reports/BusinessTaxReports"
import Regions from "pages/Countries/Regions/Regions"
import AddRegion from "pages/Countries/Regions/AddRegion"
import Cities from "pages/Countries/Cities/Cities"
import AddCity from "pages/Countries/Cities/AddCity"
import Faq from "pages/Faq/Faq"
import AddFaq from "pages/Faq/AddFaq"
import FaqDetails from "pages/Faq/FaqDetails"
import RegionDetails from "pages/Countries/Regions/RegionDetails"
import CityDetails from "pages/Countries/Cities/CityDetails"
import Combos from "pages/Menus/Combos/Combos"
import AddCombo from "pages/Menus/Combos/AddCombo"
import ComboDetails from "pages/Menus/Combos/ComboDetails"
import Bookings from "pages/Bookings/Bookings"
import BookingDetails from "pages/Bookings/BookingDetails"
import GenerateQRCode from "pages/QRCode/GenerateQRCode"
import RatingQuestions from "pages/Ratings/RatingQuestions"
import AddQuestion from "pages/Ratings/AddQuestion"
import QuestionDetails from "pages/Ratings/QuestionDetails"
import BranchRatings from "pages/Ratings/BranchRatings"
import BranchRatingDetails from "pages/Ratings/BranchRatingDetails"
import ItemGroups from "pages/Menus/ItemGroups/ItemGroups"
import AddItemGroup from "pages/Menus/ItemGroups/AddItemGroup"
import ItemGroupDetails from "pages/Menus/ItemGroups/ItemGroupDetails"
import LoyaltyPointsReports from "pages/Reports/LoyaltyPointsReports"
import ExportRequests from "pages/Authentication/ExportRequests"
import APIKey from "pages/PosSettings/APIKey"
import MenuSync from "pages/PosSettings/MenuSync"
import BranchSync from "pages/PosSettings/BranchSync"
import BranchSyncDetails from "pages/PosSettings/BranchSyncDetails"
import AddEmail from "pages/Settings/AddEmail"
import AppSettings from "pages/AppSettings/AppSettings"
import TermsAndConditions from "pages/TermsAndConditions/TermsAndConditions"
import PrivacyPolicy from "pages/TermsAndConditions/PrivacyPolicy"
import AppPrivacyPolicy from "pages/PageContent/AppPrivacyPolicy"
import AppTermsConditions from "pages/PageContent/AppTermsConditions"
import AppDeleteAccount from "pages/PageContent/AppDeleteAccount"
import AppPublicRating from "pages/PageContent/AppPublicRating"
import Vehicles from "pages/Vehicles/Vehicles"
import AddVehicle from "pages/Vehicles/AddVehicle"
import VehicleDetails from "pages/Vehicles/VehicleDetails"
import GiftCard from "pages/GiftCard"
import AddGiftCard from "pages/GiftCard/AddGiftCard"
import GiftCardDetails from "pages/GiftCard/GiftCardDetails"
import GiftCardUsage from "pages/GiftCard/GiftCardUsage"
import GiftCardUsageDetails from "pages/GiftCard/GiftCardUsage/GiftCardUsageDetails"
import DynamicLink from "pages/DynamicLink/DynamicLink"
import EidiyahSettings from "pages/Settings/EidiyahSettings"
import OrderCancelSettings from "pages/Settings/OrderCancelSettings"
import DeliverySettings from "pages/Settings/DeliverySettings"
import DeliveryPartnerSettings from "pages/Settings/DeliveryPartnerSettings"
import AddCampaign from "pages/Campaign/AddCampaign"
import Campaign from "pages/Campaign/Campaign"
import CampaignDetails from "pages/Campaign/CampaignDetails"
import WalletReports from "pages/Reports/WalletReports"
import WalletTransferReports from "pages/Reports/WalletTransferReports"
import WalletPurchaseReport from "pages/Reports/WalletPurchaseReport"
import GiftCardReports from "pages/Reports/EidiyahReports"
import PremiumGiftCardReports from "pages/Reports/PremiumGiftCardReports"
import { components } from "react-select"
import CustomersRestore from "pages/CustomerManagement/DeletedCustomers"
import DeletedCustomerView from "pages/CustomerManagement/DeletedCustomerView"
import GiftCardCategories from "pages/GiftCard/GiftCardCategories"
import AddGiftCardCategory from "pages/GiftCard/GiftCardCategories/AddGiftCardCategory"
import GiftCardCategoryDetails from "pages/GiftCard/GiftCardCategories/GiftCardCategoryDetails"
import Templates from "pages/GiftCard/Templates"
import AddTemplate from "pages/GiftCard/Templates/AddTemplate"
import TemplateDetails from "pages/GiftCard/Templates/TemplateDetails"
import StaticMaintenance from "pages/Settings/StaticMaintenance/StaticMaintenance"
import AddStaticMaintenance from "pages/Settings/StaticMaintenance/AddStaticMaintenance"
import MenuSetup from "../pages/Menus/MenuSetup"
import AddMenuSetup from "pages/Menus/MenuSetup/AddSetup"
import ViewMenuSetup from "pages/Menus/MenuSetup/ViewMenuSetup"
import Zones from "pages/Countries/Zones/Zones"
import AddZone from "pages/Countries/Zones/AddZone"
import ZoneDetails from "pages/Countries/Zones/ZoneDetails"
import B2CSalesReport from "pages/E-StoreReports/B2CSalesReport"
import SummarySalesReport from "pages/E-StoreReports/SummarySalesReport"
import SalesReportByProduct from "pages/E-StoreReports/SalesReportByProduct"
import NotFound from "pages/Errors/NotFound"
import ServerError from "pages/Errors/ServerError"
import SessionExpired from "pages/Errors/SessionExpired"
import SystemMaintenance from "pages/Errors/SystemMaintenance"

// Billing / Subscription
import BillingDashboard from "pages/Billing/BillingDashboard"
import Plans from "pages/Billing/Plans"
import Checkout from "pages/Billing/Checkout"
import Invoices from "pages/Billing/Invoices"
import InvoiceDetails from "pages/Billing/InvoiceDetails"

// Delivery Partners
import DeliveryPartnersPage from "pages/DeliveryPartners/DeliveryPartnersPage"

// Superadmin (platform operator console — lives under pages/superadmin/)
import TenantsList from "pages/super-admin/tenants/TenantsList"
import TenantDetails from "pages/super-admin/tenants/TenantDetails"
import AddEditTenant from "pages/super-admin/tenants/AddEditTenant"
import PlansList from "pages/super-admin/plans/PlansList"
import AddEditPlan from "pages/super-admin/plans/AddEditPlan"
import SubscriptionsList from "pages/super-admin/billing/SubscriptionsList"
import AllInvoices from "pages/super-admin/billing/AllInvoices"
import SuperAdminDashboard from "pages/super-admin/dashboard/SuperAdminDashboard"
import SuperAdminRoles from "pages/super-admin/roles/Roles"
import SuperAdminAddRoles from "pages/super-admin/roles/AddRoles"
import SuperAdminRolesDetails from "pages/super-admin/roles/RolesDetails"
import SuperAdminUsers from "pages/super-admin/users/Users"
import SuperAdminDeletedUsers from "pages/super-admin/users/DeletedUsers"
import SuperAdminAddUser from "pages/super-admin/users/AddUser"
import SuperAdminViewUser from "pages/super-admin/users/ViewUser"
import IntegrationsManagement from "pages/super-admin/integrations/IntegrationsManagement"
import SuperAdminWebsiteBuilder from "pages/super-admin/website-builder/SuperAdminWebsiteBuilder"

import TenantIntegrations from "pages/IntegrationsPage/TenantIntegrations"
import SocialAuthSettings from "pages/IntegrationsPage/SocialAuthSettings"
import PublicHomeRoute from "components/PublicHomeRoute"
import CustomLoginRouteGuard from "components/CustomLoginRouteGuard"
import RegisterTenant from "pages/Onboarding/RegisterTenant"
import SelectPlan from "pages/Onboarding/SelectPlan"
import OnboardingPayment from "pages/Onboarding/Payment"
import OnboardingSuccess from "pages/Onboarding/OnboardingSuccess"
import PlanPayment from "pages/PlanPayment/PlanPayment"


/** Tenant KPI dashboard — super-admins use {@link ROUTES.SA_DASHBOARD} instead */
const TenantDashboardRoute = () => {
  const accountType = useSelector(state => state.Login?.accountType)
  const accountScope = useSelector(state => state.Login?.accountScope)
  const isSystemLoginUser = useSelector(
    state => state.Login?.authUser?.isSystemLoginUser
  )
  const storedScope =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("accountScope")
      : null
  const isSuperAdminSession =
    (accountType === "superadmin" || accountScope === "super_admin") &&
    storedScope !== "tenant" &&
    !isSystemLoginUser
  if (isSuperAdminSession) {
    return <Navigate to={ROUTES.SA_DASHBOARD} replace />
  }
  return <Dashboard />
}

const authProtectedRoutes = [
  { path: "/dashboard", component: <TenantDashboardRoute /> },

  // Locations/branches
  { path: "/branches", component: <Locations /> },
  { path: "/branches/add", component: <AddLocation mode="add" /> },
  { path: "/branches/edit", component: <AddLocation mode="edit" /> },
  { path: "/branches/branch-details", component: <ViewLocation /> },

  // Roles
  { path: "/roles", component: <Roles /> },
  { path: "/roles/add", component: <AddRoles mode="add" /> },
  { path: "/roles/edit", component: <AddRoles mode="edit" /> },
  { path: "/roles/role-details", component: <RolesDetails /> },

  // Users
  { path: "/users", component: <Users /> },
  { path: "/users/add", component: <AddUser mode={"add"} /> },
  { path: "/users/edit", component: <AddUser mode={"edit"} /> },
  { path: "/users/user-details", component: <ViewUser /> },

  // Customers
  { path: "/customers", component: <Customers /> },
  { path: "/customers/customer-details", component: <CustomersView /> },
  { path: "/customers/edit", component: <EditCustomer /> },
  { path: "/customers/loyalty", component: <CustomerLoyalty /> },
  { path: "/customers/deleted-customers", component: <CustomersRestore /> },
  {
    path: "/customers/deleted-customer-details",
    component: <DeletedCustomerView />,
  },
  { path: "/customers/loyalty/add", component: <AddLoyaltyPoints /> },

  { path: "/menus/menu-setup", component: <MenuSetup /> },
  { path: "/menus/menu-setup/add", component: <AddMenuSetup mode={"add"} /> },
  { path: "/menu/menu-setup/edit", component: <AddMenuSetup mode={"edit"} /> },
  {
    path: "/menu/menu-setup/view",
    component: <ViewMenuSetup />,
  },

  // Menus/Categories/Items/Modifier
  { path: "/menus/categories", component: <Categories /> },
  {
    path: "/menus/categories/add",
    component: <AddCategory mode={"add"} />,
  },
  {
    path: "/menus/categories/edit",
    component: <AddCategory mode={"edit"} />,
  },
  {
    path: "/menus/categories/category-details",
    component: <CategoryDetails />,
  },
  {
    path: "/menus/items",
    component: <Items mode={"allItems"} />,
  },
  {
    path: "/menus/items/add",
    component: <AddItem mode={"allItemsAdd"} />,
  },
  {
    path: "/menus/items/item-details",
    component: <ItemDetails />,
  },
  {
    path: "/menus/categories/:categoryId/items",
    component: <Items />,
  },
  {
    path: "/menus/categories/:categoryId/items/add",
    component: <AddItem mode="add" />,
  },
  {
    path: "/menus/categories/:categoryId/items/edit",
    component: <EditItem mode="edit" />,
  },
  {
    path: "/menus/categories/:categoryId/items/:itemId/edit-item",
    component: <EditItem mode="edit" />,
  },
  {
    path: "/menus/categories/:categoryId/items/:itemId/modifiers/add",
    component: <AddModifierGroup mode="add" />,
  },
  {
    path: "/menus/categories/:categoryId/items/:itemId/modifiers/edit",
    component: <AddModifierGroup mode="edit" editActionType="modifierEdit" />,
  },

  {
    path: "/menus/modifier-groups",
    component: <ModifierGroups mode="allModifierGroups" />,
  },
  {
    path: "/menus/categories/:categoryId/items/:itemId/modifiers",
    component: <ModifierGroups mode="allModifierGroups" />,
  },
  {
    path: "/menus/modifier-group-details",
    component: <ModifierGroupDetails />,
  },
  {
    path: "/menus/modifier-groups/add",
    component: <AddModifierGroup mode="allModifierAdd" />,
  },
  {
    path: "/menus/modifier-groups/edit",
    component: (
      <AddModifierGroup mode="edit" editActionType="allModifierEdit" />
    ),
  },
  {
    path: "/menus/categories/:categoryId/items/:itemId/modifiers/:modifierOptionId/items",
    component: <ModifiersItems />,
  },
  {
    path: "/menus/modifiers/:modifierOptionId/items",
    component: <ModifiersItems />,
  },
  {
    path: "/menus/categories/:categoryId/items/:itemId/modifiers/:modifierOptionId/items/add",
    component: <AddModifierOption mode="add" />,
  },
  {
    path: "/menus/categories/:categoryId/items/:itemId/modifiers/:modifierOptionId/items/edit",
    component: <AddModifierOption mode="edit" />,
  },
  {
    path: "/menus/categories/:categoryId/items/:itemId/modifiers/:modifierOptionId/items/:modifierItemId",
    component: <AddModifierOption mode="viewEdit" />,
  },
  {
    path: "/menus/modifiers",
    component: <ModifiersItems mode="allModifier" />,
  },
  {
    path: "/menus/modifiers/modifier-details",
    component: <ModifierOptionDetails />,
  },
  {
    path: "/menus/modifiers/add",
    component: <AddModifierOption mode="allModifierAdd" />,
  },
  {
    path: "/menus/modifiers/edit",
    component: <AddModifierOption mode="allModifierEdit" />,
  },
  {
    path: "/menus/combos",
    component: <Combos />,
  },
  {
    path: "/menus/combos/:comboId/items",
    component: <Combos mode="comboItems" />,
  },
  {
    path: "/menus/combos/add",
    component: <AddCombo mode="add" />,
  },
  {
    path: "/menus/combos/edit",
    component: <AddCombo mode="edit" />,
  },
  {
    path: "/menus/combos/combo-details",
    component: <ComboDetails />,
  },
  {
    path: "/menus/item-groups",
    component: <ItemGroups />,
  },
  {
    path: "/menus/item-groups/add",
    component: <AddItemGroup mode="add" />,
  },
  {
    path: "/menus/item-groups/edit",
    component: <AddItemGroup mode="edit" />,
  },
  {
    path: "/menus/item-groups/item-group-details",
    component: <ItemGroupDetails />,
  },

  // Banners
  { path: "/banners", component: <Banners /> },
  { path: "/banners/:bannerId/slides/add", component: <AddSlide mode="add" /> },
  {
    path: "/banners/:bannerId/slides/edit",
    component: <AddSlide mode="edit" />,
  },
  { path: "/offer-banners", component: <OfferBanners /> },
  {
    path: "/offer-banners/:bannerId/slides/add",
    component: <OfferAddSlide mode="add" />,
  },
  {
    path: "/offer-banners/:bannerId/slides/edit",
    component: <OfferAddSlide mode="edit" />,
  },

  // //profile
  { path: "/profile", component: <UserProfile /> },
  { path: "/change-password", component: <ChangePassword /> },
  { path: "/my-preference", component: <MyPreference /> },

  // Orders
  { path: "/orders", component: <OrdersHub /> },
  { path: "/orders/:brandId", component: <BrandOrdersPage /> },
  { path: "/orders/:brandId/order-details", component: <ViewOrder /> },
  { path: "/f&b-orders", component: <Navigate to="/orders" replace /> },
  { path: "/b2c-orders", component: <Navigate to="/orders" replace /> },
  { path: "/f&b-orders/order-details", component: <ViewOrder /> },
  { path: "/b2c-orders/order-details", component: <ViewOrder /> },
  // Countries
  { path: "/countries", component: <Countries /> },
  { path: "/countries/add", component: <AddCountry mode="add" /> },
  { path: "/countries/edit", component: <AddCountry mode="edit" /> },
  { path: "/countries/country-details", component: <CountryDetails /> },
  // Regions
  { path: "/regions", component: <Regions /> },
  { path: "/regions/add", component: <AddRegion mode="add" /> },
  { path: "/regions/edit", component: <AddRegion mode="edit" /> },
  { path: "/regions/region-details", component: <RegionDetails /> },
  // Zones
  { path: "/zones", component: <Zones /> },
  { path: "/zones/add", component: <AddZone mode="add" /> },
  { path: "/zones/edit", component: <AddZone mode="edit" /> },
  { path: "/zones/zone-details", component: <ZoneDetails /> },
  // Cities
  { path: "/cities", component: <Cities /> },
  { path: "/cities/add", component: <AddCity mode="add" /> },
  { path: "/cities/edit", component: <AddCity mode="edit" /> },
  { path: "/cities/city-details", component: <CityDetails /> },
  // Campaign
  { path: "/Giftcard-Deep-Link", component: <Campaign /> },
  { path: "/Campaign/add", component: <AddCampaign mode="add" /> },
  { path: "/Campaign/edit", component: <AddCampaign mode="edit" /> },
  { path: "/Campaign/Campaign-details", component: <CampaignDetails /> },
  // GLOBAL Settings
  { path: "/app-settings", component: <AppSettings /> },
  { path: "/giftcard-settings", component: <EidiyahSettings /> },
  { path: "/add-emails", component: <AddEmail /> },
  { path: "/vat-info", component: <Tax /> },
  { path: "/referral-settings", component: <ReferralInfo /> },
  { path: "/loyalty-settings", component: <LoyaltyPointInfo /> },
  { path: "/order-cancel-settings", component: <OrderCancelSettings /> },
  { path: "/delivery-setting", component: <DeliverySettings /> },
  { path: "/delivery-partner-settings", component: <DeliveryPartnerSettings /> },
  { path: "/user-activity", component: <UserActivity /> },
  { path: "/user-activity/details", component: <UserActivityDetails /> },

  { path: "/ingredients", component: <Ingredients /> },
  { path: "/ingredients/add", component: <AddIngredient mode="add" /> },
  { path: "/ingredients/edit", component: <AddIngredient mode="edit" /> },
  { path: "/ingredients/ingredient-details", component: <IngredientDetails /> },

  { path: "/menus/item-tags", component: <ItemTags /> },
  { path: "/menus/item-tags/add", component: <AddItemTag mode="add" /> },
  { path: "/menus/item-tags/edit", component: <AddItemTag mode="edit" /> },
  { path: "/allergens", component: <Allergens /> },
  { path: "/allergens/add", component: <AddAllergen mode="add" /> },
  { path: "/allergens/edit", component: <AddAllergen mode="edit" /> },
  { path: "/allergens/allergen-details", component: <AllergenDetails /> },

  { path: "/static-maintenance", component: <StaticMaintenance /> },
  {
    path: "/static-maintenance/add",
    component: <AddStaticMaintenance mode="add" />,
  },
  {
    path: "/static-maintenance/edit",
    component: <AddStaticMaintenance mode="edit" />,
  },

  // API LOGS
  { path: "/api-logs", component: <ApiLogs /> },
  { path: "/api-logs/api-logs-details", component: <ApiLogsDetails /> },

  // RATINGS AND REVIEWS
  // { path: "/ratings", component: <Ratings /> },
  { path: "/rating-questions", component: <RatingQuestions /> },
  { path: "/rating-questions/add", component: <AddQuestion mode="add" /> },
  { path: "/rating-questions/edit", component: <AddQuestion mode="edit" /> },
  {
    path: "/rating-questions/questions-details",
    component: <QuestionDetails />,
  },
  { path: "/branch-ratings", component: <BranchRatings /> },
  {
    path: "/branch-ratings/branch-rating-details",
    component: <BranchRatingDetails />,
  },

  // PROMOTIONS
  { path: "/discounts", component: <Promotions /> },
  { path: "/discounts/add", component: <AddPromotion mode="add" /> },
  { path: "/discounts/edit", component: <AddPromotion mode="edit" /> },
  { path: "/discounts/discount-details", component: <PromotionDetails /> },
  // COUPONS GROUP
  { path: "/coupons-group", component: <CouponsGroups /> },
  {
    path: "/coupons-group/:couponGroupId/coupons",
    component: <Coupons mode="" />,
  },
  {
    path: "coupons",
    component: <Coupons mode="allCoupons" />,
  },
  {
    path: "coupons/coupon-details",
    component: <CouponDetails />,
  },
  {
    path: "/coupons/add",
    component: <AddCoupon mode="add" />,
  },
  {
    path: "/coupons/edit",
    component: <AddCoupon mode="edit" />,
  },
  {
    path: "/coupon-usage",
    component: <CouponUsage />,
  },
  {
    path: "/coupon-usage/:couponUsageId",
    component: <CouponUsage mode="couponUsage" />,
  },
  {
    path: "/coupon-usage/details",
    component: <CouponUsageDetails />,
  },
  {
    path: "/add-digital-coupons",
    component: <AddCoupon mode="digitalAdd" />,
  },
  {
    path: "/generate-bulk-coupons",
    component: <AddBulkCoupon />,
  },

  // WALLET COUPONS
  { path: "/wallet-coupons", component: <CouponRedeem /> },
  {
    path: "/wallet-coupons/add",
    component: <AddCouponRedeem mode="add" />,
  },
  {
    path: "/wallet-coupons/edit",
    component: <AddCouponRedeem mode="edit" />,
  },
  {
    path: "/wallet-coupons/coupon-details",
    component: <CouponRedeemDetails />,
  },

  // PUSH NOTIFICATIONS
  {
    path: "/app-notifications",
    component: <AppNotifications />,
  },
  {
    path: "/app-notifications/edit",
    component: <EditAppNotification />,
  },
  {
    path: "/app-notifications/app-notification-details",
    component: <AppNotificationDetails />,
  },
  {
    path: "/push-notifications",
    component: <PushNotification />,
  },

  // CUSTOMER SUPPORT
  {
    path: "/support-issues",
    component: <IssueLists />,
  },
  {
    path: "/support-issues/add-issue",
    component: <AddIssue mode={"add"} />,
  },
  {
    path: "/support-issues/edit-issue",
    component: <AddIssue mode={"edit"} />,
  },
  {
    path: "/support-issues/issue-details",
    component: <IssueDetails />,
  },
  {
    path: "/support-tickets",
    component: <TicketLists />,
  },
  {
    path: "/support-tickets/ticket-details",
    component: <TicketDetails />,
  },

  // E-Store REPORTS
  {
    path: "/e-store/sales-report-by-product",
    component: <SalesReportByProduct />,
  },
  {
    path: "/e-store/summary-sales-report",
    component: <SummarySalesReport />,
  },
  {
    path: "/e-store/sales-order-details",
    component: <B2CSalesReport />,
  },

  // REPORTS
  {
    path: "/sales-reports",
    component: <SalesReports />,
  },

  {
    path: "/wallet-reports",
    component: <WalletReports />,
  },
  {
    path: "/wallet-transfer-reports",
    component: <WalletTransferReports />,
  },
  {
    path: "/wallet-purchase-reports",
    component: <WalletPurchaseReport />,
  },
  {
    path: "/gift-card-reports",
    component: <GiftCardReports />,
  },
  {
    path: "/premium-gift-card-reports",
    component: <PremiumGiftCardReports />,
  },
  {
    path: "/payments-reports",
    component: <PaymentsReports />,
  },
  {
    path: "/business-tax-reports",
    component: <BusinessTaxReports />,
  },
  {
    path: "/loyalty-points-reports",
    component: <LoyaltyPointsReports />,
  },

  // FAQ
  {
    path: "/faq",
    component: <Faq />,
  },
  {
    path: "/faq/add",
    component: <AddFaq mode="add" />,
  },
  {
    path: "/faq/edit",
    component: <AddFaq mode="edit" />,
  },
  {
    path: "/faq/faq-details",
    component: <FaqDetails />,
  },

  {
    path: "/terms-and-conditions",
    component: <TermsAndConditions />,
  },
  {
    path: "/privacy-policy",
    component: <PrivacyPolicy />,
  },

  // BOOKINGS
  {
    path: "/bookings",
    component: <Bookings />,
  },
  {
    path: "/bookings/booking-details",
    component: <BookingDetails />,
  },

  // QR CODE
  {
    path: "/generate-qr-code",
    component: <GenerateQRCode />,
  },
  {
    path: "/dynamic-link",
    component: <DynamicLink />,
  },

  // EXPORT REQUEST
  {
    path: "/export-requests",
    component: <ExportRequests />,
  },

  // POS SETTINGS
  {
    path: "/api-key",
    component: <APIKey />,
  },
  {
    path: "/menu-sync",
    component: <MenuSync />,
  },
  {
    path: "/branch-sync",
    component: <BranchSync />,
  },
  {
    path: "/branch-sync/details",
    component: <BranchSyncDetails />,
  },

  // VEHICLES
  {
    path: "/vehicles",
    component: <Vehicles />,
  },
  {
    path: "/vehicles/add",
    component: <AddVehicle mode="add" />,
  },
  {
    path: "/vehicles/edit",
    component: <AddVehicle mode="edit" />,
  },
  {
    path: "/vehicles/vehicle-details",
    component: <VehicleDetails />,
  },

  // BRANDS
  { path: "/brands", component: <Brands /> },
  { path: "/brands/add", component: <AddBrand mode="add" /> },
  { path: "/brands/edit", component: <AddBrand mode="edit" /> },
  { path: "/brands/brand-details", component: <BrandDetails /> },

  // GIFT CARD CATEGORIES
  {
    path: "/giftcard-categories",
    component: <GiftCardCategories />,
  },
  {
    path: "/giftcard-categories/add",
    component: <AddGiftCardCategory mode="add" />,
  },
  {
    path: "/giftcard-categories/edit",
    component: <AddGiftCardCategory mode="edit" />,
  },
  {
    path: "/giftcard-categories/details",
    component: <GiftCardCategoryDetails />,
  },

  // GIFT CARD
  {
    path: "/giftcard",
    component: <GiftCard />,
  },
  {
    path: "/giftcard/add",
    component: <AddGiftCard mode="add" />,
  },
  {
    path: "/giftcard/edit",
    component: <AddGiftCard mode="edit" />,
  },
  {
    path: "/giftcard/details",
    component: <GiftCardDetails />,
  },

  // GIFT CARD USAGE
  {
    path: "/giftcard-reports",
    component: <GiftCardUsage />,
  },
  {
    path: "/giftcard-reports/details",
    component: <GiftCardUsageDetails />,
  },

  // Templates
  {
    path: "/templates",
    component: <Templates />,
  },
  {
    path: "/templates/add",
    component: <AddTemplate mode="add" />,
  },
  {
    path: "/templates/edit",
    component: <AddTemplate mode="edit" />,
  },
  {
    path: "/templates/details",
    component: <TemplateDetails />,
  },

  // Billing / Subscription
  { path: "/billing", component: <BillingDashboard /> },
  { path: "/billing/plans", component: <Plans /> },
  { path: "/billing/checkout", component: <Checkout /> },
  { path: "/billing/invoices", component: <Invoices /> },
  { path: "/billing/invoices/details", component: <InvoiceDetails /> },

  // Delivery Partners
  { path: "/delivery-partners", component: <DeliveryPartnersPage /> },
  { path: "/delivery-partners/:id", component: <DeliveryPartnersPage /> },

  // Settings — integrations & social auth
  { path: "/settings/integrations", component: <TenantIntegrations /> },
  { path: "/settings/social-auth", component: <SocialAuthSettings /> },
  { path: "/integrations", component: <Navigate to="/settings/integrations" replace /> },

  // Superadmin — Tenants
  { path: "/superadmin", component: <Navigate to={ROUTES.SA_DASHBOARD} replace /> },
  {
    path: "/superadmin/billing",
    component: <Navigate to={ROUTES.SA_SUBSCRIPTIONS} replace />,
  },
  { path: "/superadmin/dashboard", component: <SuperAdminDashboard /> },
  { path: "/superadmin/roles", component: <SuperAdminRoles /> },
  { path: "/superadmin/roles/add", component: <SuperAdminAddRoles mode="add" /> },
  { path: "/superadmin/roles/edit", component: <SuperAdminAddRoles mode="edit" /> },
  { path: "/superadmin/roles/role-details", component: <SuperAdminRolesDetails /> },
  { path: "/superadmin/users", component: <SuperAdminUsers /> },
  { path: "/superadmin/users/deleted-users/user-details", component: <SuperAdminViewUser /> },
  { path: "/superadmin/users/deleted-users", component: <SuperAdminDeletedUsers /> },
  { path: "/superadmin/users/add", component: <SuperAdminAddUser mode="add" /> },
  { path: "/superadmin/users/edit", component: <SuperAdminAddUser mode="edit" /> },
  { path: "/superadmin/users/user-details", component: <SuperAdminViewUser /> },
  { path: "/superadmin/tenants", component: <TenantsList /> },
  { path: "/superadmin/tenants/details", component: <TenantDetails /> },
  { path: "/superadmin/tenants/add", component: <AddEditTenant mode="add" /> },
  { path: "/superadmin/tenants/edit", component: <AddEditTenant mode="edit" /> },
  { path: "/superadmin/website-builder", component: <SuperAdminWebsiteBuilder /> },

  // Superadmin — Plans
  { path: "/superadmin/plans", component: <PlansList /> },
  { path: "/superadmin/plans/add", component: <AddEditPlan mode="add" /> },
  { path: "/superadmin/plans/edit", component: <AddEditPlan mode="edit" /> },
  { path: "/superadmin/plans/view", component: <AddEditPlan mode="view" /> },

  // Superadmin — Billing Oversight
  { path: "/superadmin/billing/subscriptions", component: <SubscriptionsList /> },
  { path: "/superadmin/billing/invoices", component: <AllInvoices /> },
  { path: "/superadmin/integrations", component: <IntegrationsManagement /> },

  // Superadmin — Countries (reuses tenant country screens)
  { path: "/superadmin/countries", component: <Countries /> },
  { path: "/superadmin/countries/add", component: <AddCountry mode="add" /> },
  { path: "/superadmin/countries/edit", component: <AddCountry mode="edit" /> },
  { path: "/superadmin/countries/country-details", component: <CountryDetails /> },

]

const publicRoutes = [
  { path: "/", component: <PublicHomeRoute /> },
  {
    path: "/register",
    component: (
      <CustomLoginRouteGuard>
        <RegisterTenant />
      </CustomLoginRouteGuard>
    ),
  },
  {
    path: "/register/plans",
    component: (
      <CustomLoginRouteGuard>
        <SelectPlan />
      </CustomLoginRouteGuard>
    ),
  },
  {
    path: "/register/payment",
    component: (
      <CustomLoginRouteGuard>
        <OnboardingPayment />
      </CustomLoginRouteGuard>
    ),
  },
  {
    path: "/register/success",
    component: (
      <CustomLoginRouteGuard>
        <OnboardingSuccess />
      </CustomLoginRouteGuard>
    ),
  },
  { path: "/pay/subscription", component: <PlanPayment /> },
  { path: "/login", component: <Login /> },
  { path: "/login/otp", component: <LoginOtp /> },
  { path: "/superadmin/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/verify-password", component: <VerifyPassword /> },
  { path: "/reset-password/:uuid", component: <ResetPassword /> },
  { path: "/forbidden", component: <ForbiddenAccess /> },
  { path: "/404", component: <NotFound /> },
  { path: "/500", component: <ServerError /> },
  { path: "/session-expired", component: <SessionExpired /> },
  { path: "/system-maintenance", component: <SystemMaintenance /> },
  { path: "/:lang/privacy-policy", component: <AppPrivacyPolicy /> },
  { path: "/:lang/terms-and-conditions", component: <AppTermsConditions /> },
  { path: "/delete-account", component: <AppDeleteAccount /> },
  { path: "/rating/:branchId", component: <AppPublicRating /> },
]

export { authProtectedRoutes, publicRoutes }
